import React from 'react';
import { CaseTypeType } from '../../../Enums/CaseTypeType.enum';
import { CaseTypeTreeItem } from '../../../Hooks/useCaseTypeTree';
// @ts-ignore
import styles from './CaseTypeListItem.module.scss';
import { joinClasses } from '../../../../../Utils/className.util';
import { Theme } from '../../../../../Enums/Theme.enum';
import Button from '../../../../../Components/Button/Button';

interface Props {
	item: CaseTypeTreeItem;
	onEdit: (item: CaseTypeTreeItem) => void;
}

const CaseTypeListItem: React.FC<Props> = ({ item, onEdit }) => {
	let component;

	switch (item.caseType.type) {
		case CaseTypeType.FOLDER:
			component = (
				<div
					className={joinClasses([
						styles.item,
						!item.parentId ? styles.mainFolder : '',
					])}>
					<div className={styles.content}>
						<img src='/dist/icons/folder-open-solid.svg' />{' '}
						{item.caseType.label}
					</div>
					<div className={styles.control}>
						<Button
							title='base.shared.edit'
							theme={Theme.BLUE}
							onClick={() => onEdit(item)}
						/>
					</div>
				</div>
			);
			break;
		case CaseTypeType.CASE_TYPE:
			component = (
				<div className={joinClasses([styles.item, styles.caseType])}>
					<div className={styles.content}>{item.caseType.label}</div>
					<div className={styles.control}>
						<Button
							title='base.shared.edit'
							theme={Theme.BLUE}
							onClick={() => onEdit(item)}
						/>
					</div>
				</div>
			);
			break;
	}

	return (
		<div className={styles.wrapper}>
			{component}{' '}
			{(item.children?.length || 0) > 0 && (
				<div className={styles.childrenWrapper}>
					{item.children?.map(child => (
						<CaseTypeListItem item={child} onEdit={onEdit} key={child.id} />
					))}
				</div>
			)}
		</div>
	);
};

export default CaseTypeListItem;
